if(typeof CarouselComponent !== 'function'){
  class CarouselComponent extends HTMLElement {
    constructor() {
      super();
      
      if(this.dataset.enable != 'true') return;
      
      this.slider = this.querySelector('ul.carousel');
      this.sliderItems = this.slider.querySelectorAll('li:not(.hidden)') || [];
      this.sliderImages = this.slider.querySelectorAll('li:not(.hidden) img') || [];
      this.slideWidth = this.sliderItems[0].clientWidth;
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');
  
      if (!this.slider || !this.nextButton) return;

      if(this.sliderImages.length < 2){
        this.prevButton.remove();
        this.nextButton.remove();
      }

      const attrObserver = new MutationObserver((mutations) => {
        mutations.forEach(mu => {
          if (mu.type !== "attributes" && mu.attributeName !== "class") return;
          
          this.sliderItems = this.querySelectorAll('li:not(.hidden)') || [];
          this.slideWidth = this.sliderItems[0].clientWidth;
          this.sliderImages = this.slider.querySelectorAll('li:not(.hidden) img') || [];
          this.initializeButtons();
          this.initializeThumbnails();
        });
      });
      attrObserver.observe(this.slider, {attributes: true});

      this.initializeButtons();
      this.initializeThumbnails();
      
    }
    initializeButtons() {
      this.prevButton.classList.add('hidden');

      this.nextButton.addEventListener("click", (e) => {
        this.slider.scrollLeft += this.slideWidth;
        this.prevButton.classList.remove('hidden');

        if((this.slider.scrollLeft + (this.slideWidth * 2)) >= this.slider.scrollWidth){
          e.currentTarget.classList.add('hidden');
        }

      });
       
      this.prevButton.addEventListener("click", (e) => {
        this.slider.scrollLeft -= this.slideWidth;
        this.nextButton.classList.remove('hidden');

        if((this.slider.scrollLeft - (this.slideWidth * 2)) <= 0){
          e.currentTarget.classList.add('hidden');
        }
      });
    }
    initializeThumbnails() {
      if(this.dataset.thumbnails != 'true') return;

      this.thumbnailsContainer = this.querySelector('carousel-thumbnails');
      if(!this.thumbnailsContainer) return;

      this.thumbnailsContainer.innerHTML = '';

      this.sliderImages.forEach((img, index) => {
        this.thumbnailsContainer.innerHTML = this.thumbnailsContainer.innerHTML + `<button type="button" name="slide-${index}" aria-label="Go to Slide ${index}"><img src="${img.getAttribute('src')}" /></button>`;
      });

      this.thumbnails = this.thumbnailsContainer.querySelectorAll('button') || [];

      this.thumbnails.forEach((button, index) => {
        button.addEventListener("click", () => {
          this.slider.scrollLeft = this.slideWidth*index;
        });
      })

    }

  }

  if(customElements.get('carousel-component') === undefined) 
    customElements.define('carousel-component', CarouselComponent);
  
}